import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DatePicker from 'react-datepicker';
import update from 'react-addons-update';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import { Header, Grid, Form, Label, Icon, Input, Button } from 'semantic-ui-react';

import { Commons } from 'components';

import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

import StepThreeStaff from './StepThreeStaff';

const propTypes = {};

const defaultProps = {};

class PolicyDeductList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: moment(),
      minDate: moment(),
      oneYearDate: moment().add(1, 'y'),
      endDate: null,
      timeDisable: props.auth.schedule ? false : true,
      endDisable: false,
      isMoneySetting: false,
      isDateSetting: false,
      inputCheck: false,
      money: null,
      count: null,
      searchData: null,
      confirmShow: false,
      confirmResult: false,
      keyword: null
    };
  }

  componentWillMount() {
    const { scheduleStartDate } = this.props;

    if (scheduleStartDate && scheduleStartDate.data) {
      this.setState({
        startDate: moment(new Date(scheduleStartDate.data.start)),
        minDate: moment(new Date(scheduleStartDate.data.start))
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const nText = nextProps.text;
    const bText = this.props.text;
    let result = true;
    if (JSON.stringify(nText) != JSON.stringify(bText)) {
      result = false;
    }

    if (this.state.oneYearDate !== nextState.oneYearDate) return true;

    return result;
  }

  timeIsShow = async (e, type, params) => {
    if (type === 'sDateOrTime') {
      await this.setState({
        timeDisable: update(this.state.timeDisable, { $set: !e.target.checked })
      });
    } else if (type === 'eEndDateDel') {
      const { endDisable } = this.state;

      await this.setState({
        endDisable: update(this.state.endDisable, { $set: !endDisable }),
        endDate: update(this.state.endDate, { $set: null })
      });
    }
  };

  timeChange = (e, type, params) => {
    const { fn } = this.props;
    let value = e;

    if (type === 'sDate') {
      this.setState({
        startDate: update(this.state.startDate, { $set: e })
      });
      this.setState({
        oneYearDate: moment(e).add(1, 'y')
      });
    } else if (type === 'sDateOrTime') {
    } else if (type === 'eDate') {
      this.setState({
        endDate: update(this.state.endDate, { $set: e })
      });
    } else if (type === 'eEndDate') {
      let now = new Date();
      let lastDate = null;

      // lastDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      lastDate = moment().endOf('month');
      this.setState({
        endDate: update(this.state.endDate, { $set: lastDate })
      });

      value = lastDate;
    } else if (type === 'eEndDate1') {
      let now = new Date();
      let lastDate = null;

      // lastDate = new Date(now.getFullYear(), now.getMonth() + 2, 0);
      lastDate = moment()
        .add(1, 'months')
        .endOf('month');
      this.setState({
        endDate: update(this.state.endDate, { $set: lastDate })
      });

      value = lastDate;
    } else if (type === 'eEndDate2') {
      let now = new Date();
      let lastDate = null;

      // lastDate = new Date(now.getFullYear(), now.getMonth() + 2, 0);
      lastDate = this.state.oneYearDate;
      this.setState({
        endDate: update(this.state.endDate, { $set: lastDate })
      });

      value = lastDate;
    } else if (type === 'eEndDate3') {
      const lastDate = moment().endOf('year');
      this.setState({
        endDate: update(this.state.endDate, { $set: lastDate })
      });
    }

    // fn.stepThreeAllBtn(value, type, params)
  };

  dateSetting = async (e, params, result) => {
    const { startDate, endDate, timeDisable, endDisable, isDateSetting } = this.state;
    const { time, fn } = this.props;

    if (endDate || endDisable) {
      let confirmResult = result ? result : false;

      if (confirmResult) {
        // let sDate = !timeDisable ? moment(startDate).format("YYYY-MM-DD") + " " + time.sTime : null;
        // let eDate = !endDisable ? endDate ? endDate.format("YYYY-MM-DD") + " 11:59:59 PM" : null : null;
        let sDate = null;
        let eDate = null;
        if (!timeDisable) {
          let ttt = moment(time.sTime, 'HH:mm A');
          sDate = moment(startDate);
          sDate = sDate.set({
            hour: ttt.get('hour'),
            minute: ttt.get('minute')
          });
        }
        if (!endDisable && endDate) {
          eDate = moment(endDate.format('YYYY-MM-DD'));
          eDate = eDate.set({
            hour: 23,
            minute: 59,
            second: 59
          });
        }

        let result = true;

        if (eDate) {
          result = cm.dateCheck(sDate, eDate, false); //날짜 체크
          if (!result.isState) {
            toastr('top-right', 'warning', result.message);
            result = false;
          }
        }

        if (result) {
          params['startDate'] = moment(sDate).format('YYYY-MM-DDTHH:mm');
          params['time'] = !timeDisable ? time : null;
          params['endDate'] = eDate;
          params['isDateSetting'] = confirmResult;
          await this.setState({
            isDateSetting: update(this.state.isDateSetting, { $set: confirmResult })
          });
        } else {
          return;
        }
      }

      //유효기간 설정완료 버튼 일 때
      if (!this.state.isDateSetting) {
        //식대 시작시각 예약하기를 체크 하지 않았을 때
        if (timeDisable) {
          this.confirmOpen(true);
        } else {
          this.dateSetting(e, params, true);
        }
      } else {
        await this.setState({
          isDateSetting: update(this.state.isDateSetting, { $set: confirmResult })
        });
      }

      fn.stepThreeAllBtn(e, 'dateSetting', params);
    } else {
      toastr('top-right', 'warning', '식대유효기간을 선택하세요.');
      return;
    }
  };

  moneySettingSuccess = async (params) => {
    const { policyStaffList, tabTotalData, fn, data, handleClick } = this.props;
    const { isMoneySetting } = this.state;
    let totalMoney = 0;
    let totalCount = 0;
    let overTotalCount = 0;
    let result = true;
    let message = '';
    let type = data.topMenu.tabType;

    this.setState({ inputCheck: true });
    policyStaffList.some((data) => {
      let policyMoney = 0;
      let maxLimitPolicyMoney = Infinity;
      let giveMoney = Number(data.money);

      data.policy.some((p) => {
        if (p.idx === data.sPolicy) {
          policyMoney = p.amount;
          if (cm.isValidNumber(p.maxHoldLimitAmount)) {
            maxLimitPolicyMoney = p.maxHoldLimitAmount;
          }
          return true;
        }
      });

      if (type === 'deduct' && policyMoney < giveMoney) {
        message = '차감금액이 잔여 식대보다 큽니다. 잔여 식대보다 적게 설정해주세요.';
        result = false;
        return true;
      }

      if (data.sPolicy === params.pIdx) {
        if (data.money !== 0 && !data.money) {
          $(`#money-${data.id}`).addClass('value-null');
          message = '금액 설정을 모두 해주세요.';
          result = false;
        } else if (type !== 'deduct' && maxLimitPolicyMoney < policyMoney + giveMoney) {
          $(`#money-${data.id}`).addClass('value-null');
          message = '지급금액은 최대보유한도를 초과할 수 없습니다.';
          result = false;
          overTotalCount += 1;
        } else {
          $(`#money-${data.id}`).removeClass('value-null');
          if (!data.reason) {
            $(`#reason-${data.id}`).addClass('value-null');
            message = '사유를 모두 입력하세요.';
            result = false;
          } else {
            $(`#reason-${data.id}`).removeClass('value-null');
          }
        }
        totalMoney += giveMoney;
        totalCount += 1;
      }
    });

    await this.setState({
      overTotalCount: update(this.state.overTotalCount, { $set: overTotalCount })
    });

    if (result) {
      await this.setState({
        isMoneySetting: update(this.state.isMoneySetting, { $set: !isMoneySetting }),
        money: update(this.state.money, { $set: totalMoney }),
        count: update(this.state.count, { $set: totalCount })
      });

      params['isMoneySetting'] = !isMoneySetting;
      params['totalMoney'] = totalMoney;
      params['totalCount'] = totalCount;

      fn.tabTotalData('moneySetting', params);
      handleClick(null, { index: params.pIdx }, 'open');
    } else {
      toastr('top-right', 'warning', message);
      return;
    }
  };

  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      const { text, policyStaffList } = this.props;

      if (text && text.value) {
        let keyword = text ? text.value : null;
        let temp = [];

        policyStaffList.forEach((data, idx) => {
          if ((data.signid && data.signid.indexOf(keyword) > -1) || (data.name && data.name.indexOf(keyword) > -1)) {
            temp.push(data);
          }
        });

        if (temp.length === 0) {
          toastr('top-right', 'warning', '검색결과가 없습니다.');
          return;
        }

        this.setState({
          searchData: temp.length > 0 ? temp : null,
          keyword: keyword
        });
      } else {
        this.setState({
          searchData: null
        });
      }
    }
  };

  confirmOpen = (isShow, result) => {
    const { policyStaffList, handleClick } = this.props;
    const params = {
      gIdx: policyStaffList ? policyStaffList[0].group.idx : null,
      pIdx: policyStaffList ? policyStaffList[0].sPolicy : null
    };

    if (result) {
      this.dateSetting(null, params, result);
    }

    this.setState({
      confirmShow: isShow
    });

    if (!isShow) {
      handleClick(null, { index: params.pIdx }, 'open');
    }
  };

  render() {
    const { policyStaffList, fn, data, auth } = this.props;
    const {
      startDate,
      endDate,
      timeDisable,
      endDisable,
      money,
      count,
      overTotalCount,
      isDateSetting,
      isMoneySetting,
      searchData,
      oneYearDate,
      minDate,
      confirmShow,
      keyword,
      inputCheck
    } = this.state;

    const params = {
      gIdx: policyStaffList ? policyStaffList[0].group.idx : null,
      pIdx: policyStaffList ? policyStaffList[0].sPolicy : null
    };

    const date = {
      sDate: policyStaffList ? policyStaffList[0].sDate : null,
      eDate: policyStaffList ? policyStaffList[0].eDate : null,
      time: policyStaffList ? policyStaffList[0].time : null
    };

    const stepThreeStaffProps = {
      data: {
        topMenu: data.topMenu,
        inputCheck
      }
    };

    const mm = cm.dataNextMonth(1);
    const mm2 = cm.dataNextMonth(2);
    let isMinus = data.topMenu.tabType === 'give' ? '' : '(-)';

    const confirmStyle = {
      width: '660px',
      fontSize: '16px',
      fontWeight: 'bold'
    };
    return (
      <div className="step-three-staff">
        <Commons.ConfirmContent
          openFunc={this.confirmOpen}
          confirmShow={confirmShow}
          style={confirmStyle}
          text={'시작시각을 설정하지 않고, 유효기간 설정을 완료하시겠습니까?'}
        />
        <div>
          <Header as="h3" dividing>
            <div className="title1">
              <span>식대 유효기간 설정</span>
            </div>
            <div className="title2">
              {data.topMenu.tabType === 'give' ? (
                <span>*예약을 설정하지 않으면, 지금 바로 식대가 지급됩니다.</span>
              ) : null}
            </div>
          </Header>
        </div>
        <div>
          {data.topMenu.tabType === 'give' ? (
            <Form>
              <div className={isDateSetting ? 'date-setting dim' : 'date-setting'}>
                <Form.Group inline>
                  <div className="checkbox pure">
                    <label>
                      <input
                        type="checkbox"
                        checked={auth.schedule ? true : null}
                        onChange={auth.schedule ? false : (e) => this.timeIsShow(e, 'sDateOrTime', params)}
                      />
                      <span></span>
                    </label>
                  </div>
                  <span>지급 예약</span>
                </Form.Group>
                <Form.Group inline>
                  <Input labelPosition="right" type="text" placeholder="Amount">
                    <Label basic>
                      <Icon disabled name="calendar" />
                    </Label>
                    <DatePicker
                      className="startDate"
                      customInput={<input style={{ width: 170 }} />}
                      selected={startDate}
                      minDate={minDate}
                      dateFormat="YYYY-MM-DD"
                      disabled={auth.schedule ? false : timeDisable}
                      onChange={(e) => this.timeChange(e, 'sDate', params)}
                    />
                  </Input>
                  <Commons.Time
                    timeType="sTime"
                    placeholder={'HH:mm'}
                    isShowSecond={false}
                    isDim={auth.schedule ? false : timeDisable}
                  />
                  <span className="test-stick"> - </span>
                  <Input labelPosition="right" type="text" placeholder="Amount">
                    <Label basic>
                      <Icon disabled name="calendar" />
                    </Label>
                    <DatePicker
                      className="endDate"
                      customInput={<input style={{ width: 170 }} />}
                      selected={endDate}
                      minDate={minDate}
                      dateFormat="YYYY-MM-DD"
                      disabled={endDisable}
                      onChange={(e) => this.timeChange(e, 'eDate', params)}
                    />
                  </Input>
                  {!auth.schedule ? (
                    <Button
                      inverted
                      className="date-btn1"
                      color="black"
                      disabled={endDisable}
                      onClick={(e) => this.timeChange(e, 'eEndDate', params)}
                    >
                      {mm + '월 말일까지'}
                    </Button>
                  ) : null}
                  <Button
                    inverted
                    className="date-btn1"
                    color="black"
                    style={{ marginLeft: 0 }}
                    disabled={endDisable}
                    onClick={(e) => this.timeChange(e, 'eEndDate1', params)}
                  >
                    {mm2 + '월 말일까지'}
                  </Button>
                  <Button
                    inverted
                    className="date-btn1"
                    color="black"
                    style={{ marginLeft: 0, width: 170 }}
                    disabled={endDisable}
                    onClick={(e) => this.timeChange(e, 'eEndDate2', params)}
                  >
                    {`${oneYearDate.format('YYYY-MM-DD')} 까지`}
                  </Button>
                  <Button
                    inverted
                    className="date-btn1"
                    color="black"
                    style={{ marginLeft: 0, width: 170 }}
                    disabled={endDisable}
                    onClick={(e) => this.timeChange(e, 'eEndDate3', params)}
                  >
                    올해말까지
                  </Button>
                  <Button
                    inverted={!endDisable}
                    className="date-btn2"
                    color="black"
                    style={{ width: 170 }}
                    onClick={(e) => this.timeIsShow(e, 'eEndDateDel', params)}
                  >
                    유효기간 제한 없음
                  </Button>
                </Form.Group>
              </div>
              <Form.Group className="time-setting">
                <Button inverted color="green" onClick={(e) => this.dateSetting(e, params)}>
                  {isDateSetting ? '재설정' : '유효기간 설정완료'}
                </Button>
                <span id={'time-setting' + params.pIdx}>
                  {isDateSetting && timeDisable
                    ? '지급시간부터'
                    : isDateSetting
                    ? moment(date.sDate).format('YYYY-MM-DD') + '  '
                    : null}
                  {isDateSetting && date.time ? moment(date.sDate).format('HH:mm') + ' 부터 ' : null}
                  {isDateSetting && endDisable
                    ? '  식대 유효기간 없음'
                    : isDateSetting && date.eDate
                    ? moment(endDate).format('YYYY-MM-DD') + ' 24:00까지 '
                    : null}
                  {isDateSetting ? null : <span>유효기간을 설정해주세요.</span>}
                </span>
              </Form.Group>
            </Form>
          ) : (
            <span className="deduct-date-text">차감은 신청 즉시 차감되며, 유효시간을 설정할수 없습니다.</span>
          )}
          <div className={isMoneySetting ? 'dim' : ''}>
            <div>
              <Header as="h4" dividing className="count-line">
                <div className=""></div>
              </Header>
              <div>
                <span className="user-cnt">{'금액 및 사유 입력 (총' + policyStaffList.length + ' 명)'}</span>
              </div>
              <div className="search-box">
                <Commons.SearchInputBox handleEntSubmit={this.handleEntSubmit} placeHolder={'ID, 이름'} />
              </div>
            </div>
            <StepThreeStaff
              fn={fn}
              data={stepThreeStaffProps.data}
              policyStaffList={searchData ? searchData : policyStaffList}
              keyword={keyword}
            />
          </div>
          <Form>
            <Form.Group className="money-setting">
              <Button
                inverted
                color={data.topMenu.tabType === 'give' ? 'green' : 'red'}
                onClick={(e) => this.moneySettingSuccess(params)}
              >
                {isMoneySetting ? '재설정' : '금액 설정완료'}
              </Button>
              {count ? <span>{count + '명 '}</span> : null}
              {money ? <span>{'총 ' + isMinus + cm.numberComma(money) + '원(장)'}</span> : null}
              {!count && !money ? <span>금액과 사유를 입력해주세요. </span> : null}
              {overTotalCount ? (
                <span>
                  <span style={{ color: 'red' }}>최대보유한도금액</span>을 초과한{' '}
                  <span style={{ color: 'red' }}>{overTotalCount}명</span>에게는 지급이 불가합니다. 금액을 조정해
                  주세요.
                </span>
              ) : null}
            </Form.Group>
          </Form>
        </div>
      </div>
    );
  }
}

PolicyDeductList.propTypes = propTypes;
PolicyDeductList.defaultProps = defaultProps;

PolicyDeductList = connect((state) => ({
  time: state.commons.time,
  text: state.commons.text,
  scheduleStartDate: state.sikdae.scheduleStartDate
}))(PolicyDeductList);

export default PolicyDeductList;
